import { createContext } from 'react';

const IsMobileContext = createContext(false);

export default IsMobileContext;
